import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { ClientGuestListResponse } from '~client/model/client-guest-list-response';
import { SimpleMarketplaceResponse } from '~client/model/simple-marketplace-response';
import { CreateClientGuestOfferGroupRequest } from '~client/model/create-client-guest-offer-group-request';
import { ClientGuestInvitationResponse } from '~client/model/client-guest-invitation-response';
import { ResponseEntity } from '~client/model/response-entity';
import { compilePath } from '~common/route/path-to-regexp';

/* Functions for maintaining Client Guest */
export class ClientGuestController extends BaseController {
  public getGuestList$(eventId: number): Observable<ClientGuestListResponse> {
    return this.get$('/client/guest/list', { eventId });
  }

  public getGuestMarketplace$(eventId: number): Observable<SimpleMarketplaceResponse> {
    return this.get$('/client/guest/marketplace', { eventId });
  }

  /* Allows a Client login to assign inventory to users */
  public assignInventory$(
    request: CreateClientGuestOfferGroupRequest,
  ): Observable<ClientGuestInvitationResponse> {
    return this.post$('/client/guest/assign', request);
  }

  /* Allows a client to resend a guest list invitation */
  public resendGuestInvite$(offerGroupId: number): Observable<ResponseEntity> {
    return this.post$(
      compilePath('/client/guest/resend')({ queryParams: { offerGroupId: offerGroupId } }),
    );
  }

  /* Allows a client to revoke a guest list invitation */
  public revokeGuestInvite$(offerGroupId: number): Observable<ResponseEntity> {
    return this.post$(
      compilePath('/client/guest/revoke')({ queryParams: { offerGroupId: offerGroupId } }),
    );
  }

  /* Allows a client to refund a guest list invitation that was accepted for free. */
  public refundGuestInviteFree$(offerGroupId: number): Observable<ResponseEntity> {
    return this.post$(
      compilePath('/client/guest/refund')({ queryParams: { offerGroupId: offerGroupId } }),
    );
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/controller/client-guest-controller.ts